// extracted by mini-css-extract-plugin
module.exports = {"lia-icon-field":"FormField_lia-icon-field__txBQ1","lia-label":"FormField_lia-label__TOMHO","lia-form-error":"FormField_lia-form-error__GJbOo"};